import React, { ReactElement } from 'react';
import StructureService from '../../services/structure-service';
import useCurrentUserPermissions from '../../hooks/use-current-user-permissions';

const CheckAccess: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement | null => {
  const {
    isEnabled,
    permissions,
    children,
  } = props;

  const permissionList: string[] = useCurrentUserPermissions();

  const isCheckAccessEnabled: boolean = isEnabled === undefined ? true : isEnabled;

  if (permissions && permissions.length) {
    let isAllowed: boolean = false;
    for (let permissionIndex: number = 0; permissionIndex < permissions.length; permissionIndex++) {
      isAllowed = isAllowed || StructureService.checkPermission(permissions[permissionIndex], permissionList);
    }

    if (!isAllowed && isCheckAccessEnabled) {
      return null;
    }
  }

  return children;
});

export default CheckAccess;
